import axios from 'axios';
import HelperS from '@/shared-modules/services/helper.service';
import store from '@/store';
import { smallNotification } from '@shared/services/gf.notification.service';

export default {
  // Service

  // Project
  getProjectMembersUsers(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/setting/user-members`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setProjectMembersUsers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      });
  },
  getProjectMembersTeams(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/setting/team-members`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setProjectMembersTeams', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      });
  },
  getProjectRoles(userAlias, projectAlias) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/setting/roles`)
      .then((res) => {
        store.dispatch('setEntityRoles', res.data);
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  deleteProjectUser(userAlias, projectAlias, userUuid, data) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/setting/member/${userUuid}/remove`)
      .then((res) => {
        if (data.currentUser === data.userToDeleteAlias) window.location.href = '/project';
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  deleteProjectTeam(userAlias, projectAlias, teamUuid) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/setting/member/${teamUuid}/remove-team`)
      .then((res) => {
        smallNotification('success', { title: 'Команда удалена' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  editProjectUserRole(userAlias, projectAlias, form) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/setting/member/edit-user-role`, form)
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  editProjectTeamRole(userAlias, projectAlias, form) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/setting/member/edit-team-role`, form)
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },

  // Team
  getTeamMembers(teamAlias, params) {
    return axios
      .get(`/api/team/${teamAlias}/setting/member`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setTeamMembers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  getTeamRoles(teamAlias) {
    return axios
      .get(`/api/team/${teamAlias}/setting/roles`)
      .then((res) => {
        store.dispatch('setEntityRoles', res.data);
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  editTeamUserRole(teamAlias, form) {
    return axios
      .post(`/api/team/${teamAlias}/setting/member/edit-role`, form)
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  deleteTeamUser(teamAlias, userUuid, data) {
    return axios
      .post(`/api/team/${teamAlias}/setting/member/${userUuid}/remove`)
      .then((res) => {
        if (data.currentUser === data.userToDeleteAlias) window.location.href = '/team';
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  ldapTeamRemoveUser(teamAlias, userAlias, action) {
    return axios
      .post(`/api/team/${teamAlias}/setting/member/${userAlias}`, null, {
        params: { action: action }
      })
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },

  // Company
  getCompanyMembers(companyAlias, params) {
    return axios
      .get(`/api/company/${companyAlias}/setting/member`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setCompanyMembers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  getCompanyRoles(companyAlias) {
    return axios
      .get(`/api/company/${companyAlias}/setting/roles`)
      .then((res) => {
        store.dispatch('setEntityRoles', res.data);
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  deleteCompanyUser(companyAlias, userUuid, data) {
    console.log(data);
    return axios
      .post(`/api/company/${companyAlias}/member/${userUuid}/remove`)
      .then((res) => {
        if (data.currentUser === data.userToDeleteAlias) window.location.href = '/company';
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  editCompanyUserRole(companyAlias, form) {
    return axios
      .post(`/api/company/${companyAlias}/setting/member/edit-role`, form)
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  ldapCompanyRemoveUser(companyAlias, userAlias, action) {
    return axios
      .post(`/api/company/${companyAlias}/setting/member/${userAlias}`, null, {
        params: { action: action }
      })
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },

  // Admin

  // Project
  getAdminProjectMembersUsers(projectUuid, params) {
    return axios
      .get(`/api/admin/project/${projectUuid}/user-members`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setProjectMembersUsers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  getAdminProjectMembersTeams(projectUuid, params) {
    return axios
      .get(`/api/admin/project/${projectUuid}/team-members`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setProjectMembersTeams', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  getAdminProjectRoles(projectUuid) {
    return axios
      .get(`/api/admin/project/${projectUuid}/roles`)
      .then((res) => {
        store.dispatch('setEntityRoles', res.data);
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  editAdminProjectUserRole(projectUuid, form) {
    return axios
      .post(`/api/admin/project/${projectUuid}/member/edit-user-role`, form)
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  editAdminProjectTeamRole(projectUuid, form) {
    return axios
      .post(`/api/admin/project/${projectUuid}/member/edit-team-role`, form)
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  deleteAdminProjectUser(projectUuid, userUuid) {
    return axios
      .post(`/api/admin/project/${projectUuid}/member/${userUuid}/remove`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  deleteAdminProjectTeam(projectUuid, teamUuid) {
    return axios
      .post(`/api/admin/project/${projectUuid}/member/${teamUuid}/remove-team`)
      .then((res) => {
        smallNotification('success', { title: 'Команда удалена' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },

  // Team
  getAdminTeamMembers(teamUuid, params) {
    return axios
      .get(`/api/admin/team/${teamUuid}/member`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setTeamMembers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  getAdminTeamRoles(teamUuid) {
    return axios
      .get(`/api/admin/team/${teamUuid}/roles`)
      .then((res) => {
        store.dispatch('setEntityRoles', res.data);
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  editAdminTeamUserRole(teamUuid, form) {
    return axios
      .post(`/api/admin/team/${teamUuid}/member/edit-user-role`, form)
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  deleteAdminTeamUser(teamUuid, userUuid) {
    return axios
      .post(`/api/admin/team/${teamUuid}/member/${userUuid}/remove`)
      .then((res) => {
        smallNotification('success', { title: 'Пользователей удален' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  ldapAdminTeamRemoveUser(teamUuid, userUuid, action) {
    return axios
      .post(`/api/admin/team/${teamUuid}/member/${userUuid}`, null, {
        params: { teamUuid: teamUuid, action: action }
      })
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },

  // Company
  getAdminCompanyMembers(companyUuid, params) {
    return axios
      .get(`/api/admin/company/${companyUuid}/member`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setCompanyMembers', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  getAdminCompanyRoles(companyUuid) {
    return axios
      .get(`/api/admin/company/${companyUuid}/roles`)
      .then((res) => {
        store.dispatch('setEntityRoles', res.data);
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  editAdminCompanyUserRole(companyUuid, form) {
    return axios
      .post(`/api/admin/company/${companyUuid}/member/edit-user-role`, form)
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  deleteAdminCompanyUser(companyUuid, userUuid) {
    return axios
      .post(`/api/admin/company/${companyUuid}/member/${userUuid}/remove`)
      .then((res) => {
        smallNotification('success', { title: 'Пользователь удален' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  ldapAdminCompanyRemoveUser(companyUuid, userUuid, action) {
    return axios
      .post(`/api/admin/company/${companyUuid}/member/${userUuid}`, null, {
        params: { companyUuid: companyUuid, action: action }
      })
      .then((res) => {
        smallNotification('info', { title: 'Изменения применены' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  }
};
